import { getAction } from '@/api/manage'
export const queryWhiteListByGroupCode = async params => {
  const response = await getAction('/alert/iotAlertWhitelist/list', params)
  return response
}
